import React from 'react';
import MatGapCoreTransactionList from './MatGapCoreTransactionList';

export default function MatGapTxnList() {
  return (
    <MatGapCoreTransactionList
      title="GAP Material - All Transactions"
      opTypes={[
        'incoming',
        'transfer',
        'issue',
        'assign',
        'return',
        'sendback',
        'adjustment',
      ]}
    />
  );
}
